import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import gsap from 'gsap';

@Component({
  selector: 'fgb-tab',
  standalone: true,
  imports: [CommonModule, FGBSharedModule],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
})
export class TabComponent implements AfterViewInit {
  @Input() selectedIndex = 0;
  @Input() tabs: string[] = [];
  @ViewChild('indicator', { static: true }) indicatorRef!: ElementRef;
  @ViewChild('tabsContainer', { static: true }) tabsContainerRef!: ElementRef;
  @Output() tabSelectionChange: EventEmitter<number> = new EventEmitter<number>();
  resizeTimeout: any;
  @HostListener('window:resize')
  onResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(
      () =>
        this._init((width: number, x: number) => {
          gsap.to(this.indicatorRef.nativeElement, {
            width: width,
            x: x,
            duration: 0.3,
            ease: 'power2.out',
          });
        }),
      100
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._init((width: number, x: number) => {
        gsap.set(this.indicatorRef.nativeElement, {
          x: x,
          width: width,
        });
      });
    }, 100);
  }

  private _init(animateFn: (width: number, x: number) => void): void {
    const containerRect = this.tabsContainerRef.nativeElement.getBoundingClientRect();
    const tab = this.tabsContainerRef.nativeElement.children[this.selectedIndex + 1];
    const tabRect = tab.getBoundingClientRect();
    const finalX = tabRect.left - containerRect.left;

    animateFn(tabRect.width, finalX);
    this.tabSelectionChange.emit(this.selectedIndex);
  }

  selectTab(index: number, event?: MouseEvent): void {
    const containerRect = this.tabsContainerRef.nativeElement.getBoundingClientRect();
    const tab = (event?.target as HTMLElement) || this.tabsContainerRef.nativeElement.children[index + 1];
    const tabRect = tab.getBoundingClientRect();
    const indicator = this.indicatorRef.nativeElement;

    const finalX = tabRect.left - containerRect.left;

    // Animate the indicator
    gsap.to(indicator, {
      duration: 0.5,
      x: finalX,
      ease: 'back.out(1.3)',
      onStart: () => {
        gsap.to(indicator, {
          duration: 0.3,
          width: tabRect.width,
          ease: 'power2.out',
        });
      },
    });

    gsap.fromTo(indicator, { scale: 0.95 }, { scale: 1, duration: 0.3, ease: 'power2.out' });

    this.selectedIndex = index;
    this.tabSelectionChange.emit(this.selectedIndex);
  }
}
